import React from "react";
import { Skeleton } from "primereact/skeleton";

const DataTableSkeleton = () => {
  return (
    <div className="text-center" style={{ width: "100%" }}>
      <>
        <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
        <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
        <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
        <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
        <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
        <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
      </>
    </div>
  );
};

export default DataTableSkeleton;
